import { useEffect } from "react"
import { FormikTouched } from "formik"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { checkDataLayerField } from "../../../../helpers/formHelpers"

type Props = {
  touched?: FormikTouched<{}>
  error?: string
  name: string
  focus?: boolean
  children: JSX.Element
  isChanged: boolean
}

export const WrapperDataLayer = ({ touched, error, name, focus, children, isChanged }: Props) => {
  useEffect(() => {
    if (focus) {
      pushToDataLayer({
        event: "GAFormEvent",
        eventCategory: "fieldFocused",
        eventAction: name,
        eventLabel: globalThis?.location?.href,
        placement: "main",
      })
    }
  }, [focus, name])

  useEffect(() => {
    checkDataLayerField(touched, error, name, isChanged)
  }, [error, name, touched, isChanged])
  return children
}
